import React, { useState } from "react";
import { BsFiletypePdf, BsFiletypeXlsx } from "react-icons/bs";
import { RiFileExcel2Line, RiCloseCircleFill } from "react-icons/ri";

const FilePreview = ({ files, removeFile }) => {
  return (
    <div className="pl-4 pr-4 flex flex-col justify-end h-20 w-full rounded-lg mb-2">
      <div className="flex justify-start h-full w-full overflow-x-auto items-center">
        {files.length === 0 ? (
          <div className="flex justify-center h-full w-[20%] rounded-xl"></div>
        ) : (
          files.map((file) => {
            return (
              <div
                key={file.name}
                className="flex-shrink-0 flex flex-col justify-center h-full w-[20%] border-2 border-gray-300 rounded-xl mr-1 relative"
              >
                <div className="absolute top-0 right-0">
                    <button className="mr-1 mt-1 close-icon" onClick={(e) => {
                        e.stopPropagation()
                        removeFile(file)
                    }}>
                        <RiCloseCircleFill size={20} color="#F32013"/>
                    </button>
                </div>
                {file.type.includes("pdf") && (
                  <div className="w-full h-full flex items-center justify-center">
                    <BsFiletypePdf color="#F40F02" size={50} />
                  </div>
                )}
                {file.type.includes("spreadsheetml") && (
                  <div className="w-full h-full flex items-center justify-center">
                    <BsFiletypeXlsx color="#1D6F42" size={50} />
                  </div>
                )}
                {file.type.includes("ms-excel") && (
                  <div className="w-full h-full flex items-center justify-center">
                    <RiFileExcel2Line color="#1D6F42" size={50} />
                  </div>
                )}
                {file.type.includes("image") && (
                  <img
                    src={file.preview}
                    alt={file.name}
                    className="h-full w-full rounded-xl"
                  />
                )}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default FilePreview;
